import cp from '../assets/imgs/cp.webp'
import '../assets/Navbar.css'
import ChannelPartnerForm from './CpForm'
function CP() {
    return (

        <>

            <div className="cp-hero">
                <img src={cp} loading="lazy" alt="CP" />
            </div>

            <ChannelPartnerForm />


        </>

    )

}
export default CP